import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { ImportObjectService } from '@common/services/import-object.service';
import { getImportObjects, storeImportObjects } from '@store/actions/import_objects.actions';

@Injectable()
export class ImportObjectsEffects {
  private readonly actions$ = inject(Actions);
  private readonly importService = inject(ImportObjectService);

  getImportObjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getImportObjects),
      exhaustMap(() =>
        this.importService.getImportsList().pipe(
          map((importProcesses) => {
            return storeImportObjects({ list: importProcesses });
          }),
          catchError(() => EMPTY),
        ),
      ),
    ),
  );
}
